<app-email-batch-history-table
  [refreshData]="refreshHistoryData"></app-email-batch-history-table>
